import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import { swipeToggleStatus } from '../../App/common/reduxs/swipe/reduxApi';
import { SWIPE_STYLE } from '../../App/common/styles/swipe_style';
import { getRoleAuth } from '../../App/login/redux/authApi';
import { getProfil } from '../profile/redux/reduxApi';
import {
  getAnnouncements,
  downloadFile,
} from '../_features/announcement/redux/reduxApi';
import {
  getTingkats,
  setReadActivity,
} from '../_features/pembelajaran/redux/reduxApi';
// import { getPembelajaran } from './redux/reduxApi';
import { getActivities } from './redux/reduxApi';
import { getSlideshows } from '../_features/slideshow/redux/reduxApi';
import AnnouncementWidget from './AnnouncementWidget';
import SlideShowWidget from './SlideShowWidget';
import ActivitiesWidget from './ActivitiesWidget';
import { openModal } from '../../App/modals/redux/modalActions';
import { getUnreadPesan } from './redux/reduxApi';
// import EmailRecovery from './EmailRecovery';
import {
  getLocalStorage,
  // setLocalStorage,
} from '../../App/common/localstorage';
// import PembelajaranWidget from './PembelajaranWidget';

function mapState(state) {
  let auth = state.auth;
  let scope = auth?.isAuth ? auth.authorities : {};
  let sprofil = state.sprofil;
  let deviceId = auth?.deviceId;
  if (deviceId) auth.name = auth.username;

  let pembelajaran = state.pembelajaran;
  const materis = pembelajaran?.materis;
  const tugass = pembelajaran?.tugass;
  const latihans = pembelajaran?.latihans;
  const tess = pembelajaran?.tess;
  let tingkats = pembelajaran?.tingkats;
  let kelass = pembelajaran?.kelass;
  let total = pembelajaran?.total;

  let sjadwal = state.sjadwal;
  let sactivities = state.sactivities;
  let snotes = state.snotes;

  let skalender = state.skalender;
  return {
    auth,
    scope: scope,
    loading: state.async.loading,
    deviceId,
    sprofil,
    role: state.userrole,
    slideshows: state.slideshows,
    announcements: state.announcements,
    materis,
    tugass,
    latihans,
    tess,
    tingkats,
    kelass,
    sjadwal,
    sactivities,
    snotes,
    skalender,
    total,
    swipe: state.swipe,
  };
}

const actions = {
  openModal,
  swipeToggleStatus,
  getRoleAuth,
  getProfil,
  getAnnouncements,
  getTingkats,
  setReadActivity,
  getActivities,
  getSlideshows,
  getUnreadPesan,
  downloadFile,
};

function Index(props) {
  let history = useHistory();
  const {
    auth,
    loading,
    openModal,
    deviceId,
    swipeToggleStatus,
    sprofil,
    getRoleAuth,
    getProfil,
    getAnnouncements,
    downloadFile,
    getTingkats,
    setReadActivity,
    getActivities,
    announcements,
    materis,
    tugass,
    latihans,
    tess,
    tingkats,
    kelass,
    sjadwal,
    sactivities,
    snotes,
    skalender,
    total,
    getSlideshows,
    getUnreadPesan,
    slideshows,
  } = props;

  const [settingApp, setSettingApp] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [hide, setHide] = useState(false);

  useEffect(() => {
    let setting = getLocalStorage('settingApp');
    setSettingApp(setting);
    setHide(settingApp?.hideMenuEmailRecovery);
  }, [settingApp?.hideMenuEmailRecovery]);

  useEffect(() => {
    if (deviceId) {
      window.ReactNativeWebView.postMessage('dash-loaded');
    }
  }, [deviceId]);

  useEffect(() => {
    getRoleAuth(auth, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getRoleAuth]);

  useEffect(() => {
    getTingkats(auth, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLink = useCallback(
    (url, id, title, content) => {
      history.push(url);
      if (id) {
        setReadActivity(auth, history, id, title, content);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setReadActivity],
  );

  // const hideEmailRecoveryForm = () => {
  //   setHide((prev) => !prev);
  //   setLocalStorage('settingApp', { hideMenuEmailRecovery: true });
  // };

  return (
    <>
      <SwipeHandler swipeToggleStatus={swipeToggleStatus} />
      <BodyCard auth={auth}>
        <SlideShowWidget
          auth={auth}
          sprofil={sprofil}
          history={history}
          loading={loading}
          slideshows={slideshows}
          getSlideshows={getSlideshows}
          handleLink={handleLink}
        />
        {/* {!hide && (
          <EmailRecovery
            history={history}
            hideEmailRecoveryForm={hideEmailRecoveryForm}
          />
        )} */}
        <AnnouncementWidget
          auth={auth}
          history={history}
          openModal={openModal}
          announcements={announcements}
          getAnnouncements={getAnnouncements}
          handleLink={handleLink}
          downloadFile={downloadFile}
        />
        <ActivitiesWidget
          auth={auth}
          history={history}
          loading={loading}
          materis={materis}
          tugass={tugass}
          latihans={latihans}
          tess={tess}
          tingkats={tingkats}
          kelass={kelass}
          sjadwal={sjadwal}
          sactivities={sactivities}
          snotes={snotes}
          skalender={skalender}
          total={total}
          getActivities={getActivities}
          handleLink={handleLink}
        />
        {/* <PembelajaranWidget
          auth={auth}
          history={history}
          loading={loading}
          materis={materis}
          tugass={tugass}
          latihans={latihans}
          tess={tess}
          tingkats={tingkats}
          kelass={kelass}
          total={total}
          getPembelajaran={getPembelajaran}
          handleLink={handleLink}
        /> */}
        <AuthContent
          auth={auth}
          history={history}
          getProfil={getProfil}
          getUnreadPesan={getUnreadPesan}
        />
      </BodyCard>
    </>
  );
}

function BodyCard({ children, auth }) {
  if (auth.isAuth !== true) return <Redirect to='/login' />;
  if (auth.isAuth === true && auth.registerParents)
    return <Redirect to='/register-2' />;

  return (
    <div className='column is-10-desktop is-offset-2-desktop is-9-tablet is-offset-3-tablet is-12-mobile'>
      <div className='p-1d'>
        <div className='columns is-gapless is-multiline is-variable is-desktop'>
          {children}
        </div>
      </div>
    </div>
  );
}
function SwipeHandler({ swipeToggleStatus }) {
  const handlers = useSwipeable({
    trackMouse: true,
    onSwipedRight: () => {
      swipeToggleStatus(true);
    },
  });
  return <div {...handlers} style={SWIPE_STYLE} />;
}

function AuthContent({ auth, history, getProfil, getUnreadPesan }) {
  useEffect(() => {
    // getProfil(auth, history);
    getUnreadPesan(auth, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}

export default connect(mapState, actions)(Index);
